/* eslint-disable max-len */
/* eslint-disable no-console */
import React, { useContext, useEffect, useRef, useState } from 'react';
import { Button } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import Accordion from '@mui/material/Accordion';
import './styles.css';
import ProgressBar from './progressBar';
import { setUploadFile } from '../../redux/MediakitRedux';
import { LanguageContext } from '../../libs/Context';
import { toast } from 'react-toastify';
import AccordainSummaryHtml from './AccordainSummaryHtml';

export default function FileUploadBox()
{
	const uploadFile = useSelector((state:any) => state.mymediakit.uploadFile);
	const [ action, setAction ] = useState<any>({
		expanded       : true,
		confirmCancel  : false,
		cancelAll      : false,
		deleteUploaded : false,
		fileUploaded   : 0,
		completed      : false
	});
	const uploadStatus:any = useRef(new Array(uploadFile?.length).fill('inprogress'));
	const dispatch = useDispatch();
	const { language } = useContext(LanguageContext);
	const { folderData } = useSelector((state: any) => state?.mymediakit?.mediaKitData);
	const mediaRef:any = useRef({ oldData: folderData });
	const timeOutRef = useRef<any>(null);

	const handleClose = () =>
	{
		const uploading = uploadStatus.current?.some(
			(status: any) => status === 'inprogress'
		);

		if (uploading) setAction({ ...action, confirmCancel: true, expanded: true });
		else
		{
			dispatch(setUploadFile([]));
		}
	};

	const handleUploadStatus = (ind, status) =>
	{
		const tempStatus = [ ...uploadStatus.current ];

		tempStatus[ind] = status;
		uploadStatus.current = tempStatus;

		const uploading = tempStatus?.every(
			(stat: any) => stat === 'completed'
		);

		if (uploading)
		{
			toast.success(`${language.folderCreatedSuccess}`, {
				position : toast.POSITION.TOP_RIGHT
			});
			// timeOutRef.current = setTimeout(() => dispatch(setUploadFile([])), 5000);
		}
	};

	const resetAction = () =>
	{
		(action.cancelAll || action.deleteUploaded) && setAction({
			expanded       : true,
			confirmCancel  : false,
			cancelAll      : false,
			deleteUploaded : false,
			fileUploaded   : 0,
			completed      : false
		});
	};

	const uploading = uploadStatus.current?.some((status: any) => status === 'inprogress');

	const uploadedCount = uploadStatus.current?.filter((status: any) => status === 'completed').length;

	useEffect(() =>
	{
		clearTimeout(timeOutRef.current);
		const newFileStatus = new Array(uploadFile?.length - uploadStatus.current?.length).fill('inprogress');

		uploadStatus.current = [ ...uploadStatus.current, ...newFileStatus ];
	}, [ uploadFile ]);

	return (
		<div className='uploadBoxContainer'>
			<div className='uploadDownload'>
				<div className='uploadcardWidth'>
					<Accordion expanded={action.expanded}>
						<AccordainSummaryHtml setAction={setAction} action={action} type='fileupload' uploading={uploading} uploadedCount={uploadedCount} uploadFile={uploadFile} handleClose={handleClose}/>
						<div className={action?.confirmCancel ? 'attchOverlay' : 'uploadBoxInnerContainer'}>
							{uploadFile?.map((item, ind) =>
								(
									<ProgressBar key={item?.name} fileData={item} index={ind} action={action} resetAction={resetAction} handleUploadStatus={(status) => handleUploadStatus(ind, status)} mediaRef={mediaRef}/>
								)
							)}
						</div>
						{action?.confirmCancel && (
							<div className='flexCol fullHeight justifyCntr alignCntr whiteBg padding40'>
								<span className='lightTxt pdngXS justifyCntr textCntr'>
									{language?.thereuploadprogress}
								</span>
								<div className='flexRow alignCntr pdngSM justifyCntr'>
									<div className='flexInline pdngXS'>
										<Button variant='outlined' className='textDanger' onClick={() => setAction({
											...action,
											cancelAll     : true,
											confirmCancel : false
										})}
										>
											{language?.stop}
										</Button>
									</div>
									<div className='flexInline pdngXS'>

										<Button variant='outlined' className='mrgnRSM textDanger' onClick={() =>
											setAction({
												...action,
												cancelAll      : true,
												deleteUploaded : true,
												confirmCancel  : false
											})}
										>
											{language?.stoprevoke}
										</Button>
									</div>
									<div className='flexInline pdngXS'>

										<Button variant='contained' color='primary' className='whiteTxt mrgnRSM' onClick={() =>
											setAction({
												...action,
												confirmCancel : false
											})}
										>
											{language?.continue}
										</Button>
									</div>
								</div>
							</div>
						)}
					</Accordion>
				</div>
			</div>
		</div>
	);
}
